import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const AirportPaginatedDropdown = (props: DropdownWithoutOptionsProps<server.dto.Airport>) => {
  const fetchAirports = async (search: string, page: number) => {
    const res = await window.CoreApi.Airport.Paginated({
      excludeKeys: props.excludeKeys ?? [],
      keyword: search,
      airportSize: "allAirports",
      page,
      perPage: 10
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchAirports}
    getLabel={a => `${a.name} (${a.iata || a.icao || a.faa})`}
    getValue={a => a.airportId}
    getSubLabel={a => a.location}
    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default AirportPaginatedDropdown;